import { render, staticRenderFns } from "./InexFeedback.vue?vue&type=template&id=49d8b786"
import script from "./InexFeedback.vue?vue&type=script&lang=js"
export * from "./InexFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports